module.exports = __webpack_public_path__ + "static/media/target-gift-card.0f102ce3.png";